import { render, staticRenderFns } from "./DocmasterAssetAllocation.vue?vue&type=template&id=4e185904&scoped=true&"
import script from "./DocmasterAssetAllocation.vue?vue&type=script&lang=js&"
export * from "./DocmasterAssetAllocation.vue?vue&type=script&lang=js&"
import style0 from "./DocmasterAssetAllocation.vue?vue&type=style&index=0&id=4e185904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e185904",
  null
  
)

export default component.exports